'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';

/**
 * PaginationButton component, use within a Pagination.Item.
 *
 * @example
 * <PaginationItem>
 *   <PaginationButton aria-label='Forrige side'>Forrige</PaginationButton>
 * </PaginationItem>
 */
const PaginationButton = forwardRef(function PaginationButton({ asChild, ...rest }, ref) {
    const Component = asChild ? Slot : 'button';
    return (jsx(Component, { className: 'ds-button', "data-variant": 'tertiary', suppressHydrationWarning // Since <ds-pagination> adds attributes
        : true, ref: ref, ...rest }));
});

export { PaginationButton };
